import { Component } from '@theme/component';
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';
import { morphSection, sectionRenderer } from '@theme/section-renderer';

class KbdBottleOffer extends Component {
  static pending = false;

  async add(event) {
    event.preventDefault();
    if (KbdBottleOffer.pending) return;
    const variantId = Number(this.dataset.variantId);
    if (!Number.isSafeInteger(variantId) || variantId <= 0) return;
    const button = this.querySelector('[ref="addButton"]');
    const status = this.querySelector('[ref="status"]');
    KbdBottleOffer.pending = true;
    if (button) button.disabled = true;
    if (status) status.textContent = '';
    let added = false;
    try {
      const readCart = async () => {
        const response = await fetch(`${Shopify.routes.root}cart.js`, { cache: 'no-store' });
        if (!response.ok) throw new Error('Cart unavailable');
        return response.json();
      };
      const cart = await readCart();
      const duplicate = cart.items.some((item) => String(item.product_id) === this.dataset.productId);
      const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component, kbd-offer-list'))
        .map((element) => element.dataset.sectionId).filter(Boolean))].slice(0, 5);
      const deferred = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(new CartLinesUpdateEvent({
        action: duplicate ? 'update' : 'add',
        context: 'cart',
        lines: [{ merchandiseId: String(variantId), quantity: 1 }],
        promise: deferred.promise,
      }));
      try {
        let response;
        if (!duplicate) {
          const request = await fetch(Theme.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections, sections_url: window.location.pathname }),
          });
          response = await request.json();
          if (!request.ok || response.status) throw new Error('Bottle unavailable');
          added = true;
        }
        const updatedCart = duplicate ? cart : await readCart();
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(updatedCart),
          detail: { items: updatedCart.items, source: 'kbd-bottle-offer', sourceId: this.id, itemCount: updatedCart.item_count, productId: this.dataset.productId, sections: response?.sections, didError: false },
        });
        if (status) status.textContent = this.dataset.added;
      } catch (error) {
        deferred.reject(error);
        throw error;
      }
    } catch {
      if (status) status.textContent = this.dataset.error;
    } finally {
      KbdBottleOffer.pending = false;
      if (button && !added) button.disabled = false;
    }
  }
}

class KbdOfferList extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.refresh);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.refresh);
  }

  refresh = async (event) => {
    try {
      const result = await event.promise;
      if (result?.detail?.didError || !this.dataset.sectionId || !this.isConnected) return;
      const html = result?.detail?.sections?.[this.dataset.sectionId];
      if (html) {
        sectionRenderer.abortRender(this.dataset.sectionId);
        await morphSection(this.dataset.sectionId, html);
      } else {
        await sectionRenderer.renderSection(this.dataset.sectionId, { cache: false });
      }
    } catch {
      this.hidden = true;
    }
  };
}

if (!customElements.get('kbd-bottle-offer')) customElements.define('kbd-bottle-offer', KbdBottleOffer);
if (!customElements.get('kbd-offer-list')) customElements.define('kbd-offer-list', KbdOfferList);
